<template>
  <div
    id="hubspotForm"
    class="app"
  >
    <SideHelpComponent
      v-if="ShowSideHelpComponent"
      class="chat-help"
      :show-side-panel="ShowSideHelpComponent"
      width="425px"
      :height="`calc(100vh - var(--px${headerHeight}))`"
      @close="ShowSideHelpComponent = false"
    />
    <AddDataSourcePopup
      v-if="addBankSuggestion && !showTrial"
      @close="closeAddBankSuggestion"
      @dashboard="closeAddBankSuggestion"
    />
    <UnlockFeaturePopup
      v-if="showFeaturePopup"
      @close="showFeaturePopup = false"
      @unlock="
        showUpgradePopup = v0Required;
        showUpgradeV1Popup = !v0Required;
        showFeaturePopup = false;
      "
    />
    <UpgradePlanPopup
      v-if="showUpgradePopup && basePlan"
      :base-plan="basePlan"
      @close="showUpgradePopup = false"
      @confirm="
        confirmUpgrade();
        showUpgradePopup = false;
      "
    />
    <UpgradePlanV1Popup
      v-if="showUpgradeV1Popup && basePlan"
      :base-plan="basePlan"
      @close="showUpgradeV1Popup = false"
      @confirm="confirmUpgrade"
    />
    <AddUserPopup
      v-if="addingUser && !mobile"
      :base-plan="basePlan"
      :company-id="addingUser.companyId"
      :employees="addingUser.employees"
      @close="addingUser = null"
      @update="updateUsersTable"
    />
    <AddUsersMobileFrame
      v-else-if="addingUser"
      :base-plan="basePlan"
      :company-id="addingUser.companyId"
      :employees="addingUser.employees"
      @close="addingUser = null"
      @update="updateUsersTable"
    />
    <AddBankPopup
      v-if="addBankPopupDisplayed && !mobile"
      :bank-and-aggregators="bankAndAggregators"
      @close="addBankPopupDisplayed = false"
    />
    <AddBanksMobileFrame
      v-else-if="addBankPopupDisplayed"
      :bank-and-aggregators="bankAndAggregators"
      @close="addBankPopupDisplayed = false"
    />
    <SubscriptionLimitPopup
      v-if="!!additionalUpdateData"
      :update-data="additionalUpdateData"
      :loading="updatingSubscription"
      @close="additionalUpdateData = null"
      @confirm="updateAdditionalSubscriptions"
    />
    <AdBlockPopup
      v-if="adBlockEnabled"
      @close="closeAdBlocker"
    />
    <AccountRemovedPopup
      v-if="accountPendingDeletion"
      :account="accountPendingDeletion"
      :bank-name="accountPendingDeletion.bank_name"
      :submitting="reviewingAccountDeletion"
      @acknowledge="confirmAccountDeletion"
      @contact-support="disputeAccountDeletion"
      @close="skipAccountPendingDeletion"
    />
    <NewAccountDetectedPopup
      v-if="detectedAccount"
      :account="detectedAccount"
      :loading="reviewingDetectedAccount"
      @approve="reviewDetectedAccount($event, true)"
      @reject="reviewDetectedAccount($event, false)"
      @close="dismissDetectedAccount"
    />
    <CpaTrialPopup
      v-if="cpaTrialLimit"
      @close="cpaTrialLimit = false"
    />
    <SigninPopup
      v-if="signinPopup"
      class="z-top"
    />
    <Card3dsValidationQueue />
    <DefaultMobileFrame
      v-if="mobile && creatingCompany"
      ref="addcmp"
      title="AJOUTER UNE ENTREPRISE"
      back-button
      @close="
        creatingCompany = false;
        dmfInput = '';
        companySiret = '';
        wrongLength = false;
      "
    >
      <div class="fy-app-dmf-container">
        <FygrInput
          v-model="dmfInput"
          class="fy-app-dmf-container-input"
          label="Entreprise"
          placeholder="Ex : Nouvelle entreprise"
          :spellcheck="false"
          :value-in="dmfInput"
          autofocus
          no-prompt
        />
        <FygrInput
          v-if="cpaCompany"
          v-model="companySiret"
          class="fy-app-dmf-container-input"
          invalid-prompt="SIRET invalide."
          label="SIRET"
          placeholder="Ex : 12345678900000"
          :invalid="wrongLength"
          :spellcheck="false"
          :value-in="companySiret"
          :validate="wrongLength"
          @input="wrongLength = false"
        />
        <div class="fy-app-dmf-container-controls">
          <FygrButton
            class="fy-app-dmf-container-confirm"
            color="orange"
            :disabled="
              !dmfInput ||
              (cpaCompany && !companySiret) ||
              wrongLength ||
              isCreatingCompany
            "
            :loading="isCreatingCompany"
            @fygr-click="
              createNewCompany({companyName: dmfInput, companySiret})
            "
          >
            Créer l'entreprise
          </FygrButton>
        </div>
      </div>
    </DefaultMobileFrame>
    <CreatingCompanyPopup
      v-else-if="creatingCompany"
      :button-disabled="wrongLength"
      :button-loading="isCreatingCompany"
      @close="
        creatingCompany = false;
        cpaCompany = null;
      "
      @confirmed="createNewCompany"
    />
    <DeleteConfirmationPopup
      v-if="(popupConfirmDeleteCompany && authorized) || deletingCompany"
      :deleting="deletingCompany"
      @close="popupConfirmDeleteCompany = false"
      @confirmed="confirmDeleteCompany"
    >
      Confirmer cette action entraînera la suppression de ce compte entreprise.
      Cette action est irréversible.
    </DeleteConfirmationPopup>
    <DeletePrimaryAccountPopup
      v-if="deletingPrimaryAcc"
      deleted-type="bank"
      :deleted-id="idToDelete"
      :mobile="mobile"
      @close="
        deletingPrimaryAcc = false;
        popupConfirmDeleteBank = false;
      "
      @confirm="deletingPrimaryAcc = false"
    />
    <DefaultMobileFrame
      v-if="
        mobile && popupConfirmDeleteBank && authorized && !deletingPrimaryAcc
      "
      ref="delbank"
      title="ÊTES-VOUS SUR ?"
      @close="
        popupConfirmDeleteBank = false;
        dmfInput = '';
      "
    >
      <div class="fy-app-dmf-container">
        <div class="fy-app-dmf-container-text translate">
          La suppression de cette banque entraînera I'effacement de toutes Ies
          données dans la base de données Okimia. Cette action est irréversible.
        </div>
        <div class="fy-app-dmf-container-text translate">
          La catégorisation des transactions contenues dans les comptes de cette
          banque sera perdue. En cas d'ajout à nouveau de cette banque par la
          suite, la plupart des organismes bancaires ne fourniront qu'un nombre
          limité de mois d'historique ce qui limitera Ia performance des
          algorithmes Okimia pendant quelques temps
        </div>
        <div class="fy-app-dmf-container-text translate">
          <div
            v-if="forecastByAccount"
            class="acc-forc translate"
          >
            Vous utilisez actuellement le prévisionnel compte par compte. Que
            voulez-vous faire des prévisionnels des comptes que vous êtes sur le
            point de supprimer ?
            <FygrSelector
              ref="selector"
              class="selector selector-mobile"
              margin-bottom="18px"
              :opts="[
                'Supprimer les prévisionnels (sauf les échéances qui seront intégrées dans le compte par défaut)',
                'Transférer les prévisionnels dans le compte bancaire par défaut',
              ]"
              :model-value="bankDelPicked === 'del' ? 0 : 1"
              @update:model-value="
                bankDelPicked = $event === 0 ? 'del' : 'transfer'
              "
            />
          </div>
        </div>

        <FygrInput
          v-model="dmfInput"
          class="fy-app-dmf-container-input"
          :label="`Entrer ${supprimerTranslated} pour confirmer`"
          :placeholder="supprimerTranslated"
          :spellcheck="false"
          :value-in="dmfInput"
          no-prompt
        />
        <div class="fy-app-dmf-container-controls">
          <FygrButton
            class="fy-app-dmf-container-confirm"
            color="red"
            :disabled="dmfInput !== supprimerTranslated || deletingBank"
            :loading="deletingBank"
            @fygr-click="confirmDeleteBank"
          >
            Supprimer
          </FygrButton>
          <a
            class="fy-app-dmf-container-cancel clickable translate"
            @click="$refs.delbank.close()"
          >
            Annuler
          </a>
        </div>
      </div>
    </DefaultMobileFrame>
    <DeleteConfirmationPopup
      v-else-if="popupConfirmDeleteBank && authorized && !deletingPrimaryAcc"
      :deleting="deletingBank"
      @close="popupConfirmDeleteBank = false"
      @confirmed="confirmDeleteBank"
    >
      La suppression de cette banque entraînera I'effacement de toutes Ies
      données dans la base de données Okimia. Cette action est irréversible.
      <br /><br />
      La catégorisation des transactions contenues dans les comptes de cette
      banque sera perdue. En cas d'ajout à nouveau de cette banque par la suite,
      la plupart des organismes bancaires ne fourniront qu'un nombre limité de
      mois d'historique ce qui limitera Ia performance des algorithmes Okimia
      pendant quelques temps
      <br /><br />
      <div
        v-if="forecastByAccount"
        class="acc-forc translate"
      >
        Vous utilisez actuellement le prévisionnel compte par compte. Que
        voulez-vous faire des prévisionnels des comptes que vous êtes sur le
        point de supprimer ?
        <FygrSelector
          ref="selector"
          class="selector"
          margin-bottom="18px"
          :opts="[
            'Supprimer les prévisionnels (sauf les échéances qui seront intégrées dans le compte par défaut)',
            'Transférer les prévisionnels dans le compte bancaire par défaut',
          ]"
          :model-value="bankDelPicked === 'del' ? 0 : 1"
          @update:model-value="
            bankDelPicked = $event === 0 ? 'del' : 'transfer'
          "
        />
      </div>
    </DeleteConfirmationPopup>
    <DeleteConfirmationPopup
      v-if="showDeleteIntegration"
      :deleting="deletingIntegration"
      @close="
        showDeleteIntegration = false;
        partnerToDelete = null;
      "
      @confirmed="deleteIntegration"
    >
      La suppression de cette intégration empêchera la synchronisation des
      données entre Okimia et
      <span class="deleting-partner-name">{{
        partnerToDelete.partner_name
      }}</span>
      à l'avenir. Les données stockées sur Okimia ne seront pas supprimées.
    </DeleteConfirmationPopup>
    <!--    <TooManyConnectionsPopup-->
    <!--      v-if="tooManyConnections"-->
    <!--      :max="customMax || maxConnections"-->
    <!--      :type="customType"-->
    <!--      @close="-->
    <!--        actionSetTooManyConnections(false);-->
    <!--        customMax = 0;-->
    <!--        customType = 'bank';-->
    <!--        isUser = true;-->
    <!--      "-->
    <!--      @confirmed="-->
    <!--        (e) => {-->
    <!--          actionConnectionsRequest(e);-->
    <!--          isUser = true;-->
    <!--          actionSetTooManyConnections(false);-->
    <!--        }-->
    <!--      "-->
    <!--    />-->
    <div
      v-if="loading"
      class="global-spinner"
    >
      <Spinner />
      <div
        v-if="loadingTitle"
        class="loading-title text-upper-big translate"
      >
        {{ loadingTitle }}
      </div>
    </div>
    <!-- Teleported to body so notifications escape #app's stacking context: screen popups
         (Popup.vue) are teleported to body too, and would otherwise render above the toast
         regardless of its z-index, hiding error messages behind the modal. -->
    <Teleport to="body">
      <div
        v-if="notifications.length"
        class="notifications translate"
        :style="
          notifications[0]?.bottomSpace !== undefined
            ? {bottom: `${notifications[0]?.bottomSpace}px`}
            : {}
        "
      >
        <div
          v-for="(n, i) in notifications"
          :key="`not-${i}`"
          :class="[`${n.color || 'gray'}-bg`, `${n.textPosition || 'centered'}`]"
          class="notification"
        >
          {{ n.msg || '' }}
          <FontAwesomeIcon
            class="close-notification-icon"
            icon="times"
            @click="() => actionRemoveNotification(n)"
          />
        </div>
      </div>
    </Teleport>
    <div
      v-if="
        (generalLoader && authorized && !finishedAuth) ||
        (!authorized &&
          (!checkNotAuthenticatedPages($route.name) ||
            checkCallbackPages($route.name)) &&
          !checkOauthNotAuthenticated($route.name))
      "
      class="general-spinner"
    >
      <Spinner
        type="big"
        style="margin: 15px auto"
      />
      <span class="text-aubergine-slim translate">Chargement en cours</span>
    </div>
    <component
      :is="layout"
      v-show="
        !generalLoader ||
        (!authorized &&
          (checkNotAuthenticatedPages($route.name) ||
            checkOauthNotAuthenticated($route.name)))
      "
      :mobile="mobile || null"
      :show-create-company="showCreateCompany"
      :show-confirm-delete-bank="showConfirmDeleteBank"
      :show-confirm-delete-company="showConfirmDeleteCompany"
      :show-confirm-delete-integration="showConfirmDeletePartnerIntegration"
      @show-add-bank-popup="showAddBankPopup"
    >
      <router-view
        v-if="
          mayBeCreated &&
          !hideApp &&
          !sepaBlockActive &&
          (!authorized || finishedAuth)
        "
        v-slot="{Component}"
        :key="keyHolder"
        :mobile="mobile || null"
        @additional-update="
          basePlan = $event;
          additionalUpdateData = $event;
        "
        @add-user="addUser"
        @create-company="showCreateCompany"
        @show-add-bank-popup="showAddBankPopup"
        @show-add-bank-suggestion="showAddBankSuggestion"
        @show-confirm-delete-bank="showConfirmDeleteBank"
        @show-confirm-delete-integration="showConfirmDeletePartnerIntegration"
        @unlock-feature="
          basePlan = $event;
          showFeaturePopup = true;
        "
        @unlock="
          basePlan = $event;
          showUpgradePopup = true;
        "
        @unlock-v1="
          basePlan = $event;
          showUpgradeV1Popup = true;
        "
        @show-hub-spot-help="ShowSideHelpComponent = true"
      >
        <component
          :is="Component"
          ref="view"
        />
      </router-view>
      <SepaPaywall v-else-if="sepaBlockActive" />
      <div
        v-else-if="hideApp"
        class="trial-expired-mngd container"
        :style="{margin: `calc(50vh - 250px) auto`}"
      >
        <LuPlaceholder>
          <div class="lu-text-trial text-gray">
            Le service a été suspendu pour cette entreprise.<br /><br />
            Vous pouvez vous rapprocher de l'utilisateur
            <a :href="`mailto:${ownerEmail}`">{{ ownerEmail }}</a> pour plus
            d'informations.
          </div>
        </LuPlaceholder>
      </div>
      <div
        v-if="
          checkRouteAllowedShowBanner(inAppMessage) &&
          inAppMessage &&
          inAppMessage.is_active &&
          !inAppMessage.is_shown
        "
        class="fy-app-in-app-message translate"
      >
        <Markdown
          class="fy-app-md-container"
          :source="mdHTML"
        />
        <FontAwesomeIcon
          class="fy-app-in-app-message-close clickable"
          icon="times"
          @click="actionHideInAppMessage()"
        />
      </div>
    </component>
    <OnboardingLayout
      v-if="!hideApp && !sepaBlockActive && !mobile && !hideOnboardingButton"
      v-show="(authorized || chapters.length === 1) && !generalLoader"
      :msg-txt="
        !!mdHTML &&
        checkRouteAllowedShowBanner(inAppMessage) &&
        inAppMessage &&
        inAppMessage.is_active &&
        !inAppMessage.is_shown &&
        mayBeCreated &&
        !hideApp &&
        (!generalLoader ||
          (!authorized &&
            (checkNotAuthenticatedPages($route.name) ||
              checkOauthNotAuthenticated($route.name))))
      "
      @show-add-bank-popup="showAddBankPopup"
    />
    <TrialLayout
      v-show="!generalLoader"
      :finish="finishSubscription"
      :mobile="mobile || null"
    />
    <FygrInteractiveNotification
      v-if="
        showReloadNotification ||
        showCompanyChangeNotification ||
        showDashboardReloadNotification
      "
      primary-text="Mettre à jour"
      secondary-text="Plus tard"
      @close="
        showReloadNotification =
          showCompanyChangeNotification =
          showDashboardReloadNotification =
            false
      "
      @primary="clearCache(!!showReloadNotification)"
      @secondary="
        showReloadNotification =
          showCompanyChangeNotification =
          showDashboardReloadNotification =
            false
      "
    >
      <span
        v-if="showReloadNotification"
        class="translate"
      >
        Une mise à jour de l'application est disponible. Cette mise à jour sera
        instantanée.</span
      >
      <p
        v-else-if="showCompanyChangeNotification"
        class="translate"
      >
        Entreprise sélectionnée modifiée dans un autre onglet. Veuillez
        actualiser la page pour rester synchronisé(e).
      </p>
      <p
        v-else-if="showDashboardReloadNotification"
        class="translate"
      >
        De nouvelles données sont disponibles. Veuillez actualiser la page pour
        mettre à jour votre tableau de bord.
      </p>
    </FygrInteractiveNotification>
  </div>
</template>

<script>
import {defineAsyncComponent, nextTick} from 'vue';
import {mapActions, mapGetters, mapState} from 'vuex';
import {companyMixin} from '@/mixins/companyMixin';
import {StripeMixin} from '@/mixins/StripeMixin';
import {cpaMixin} from '@/mixins/cpaMixin';
import {mobileMixin} from '@/mixins/mobileMixin';
import {pagesChecker} from '@/mixins/pagesCheckerMixin';
import {paywallMixin} from '@/mixins/paywallMixin';
import {appMixin} from '@/mixins/appMixin';
import {checkUpdatesMixin} from '@/mixins/checkUpdatesMixin';
import AppBus from '@/bus/app-bus';
import {
  setDataSourcePopupPending,
  resumeOnboardingAfterPopupFlow,
  isSecondSourceResolved,
  isOnboardingJourneyActive,
} from '@/tours/onboarding-recap';
import {SUPPRIMERTRANSLATED} from '@/data/locales';
import DeletePrimaryAccountPopup from '@/components/elements/ForecastsByAccount/DeletePrimaryAccountPopup.vue';
import FygrSelector from '@/components/elements/FygrSelector.vue';
// Force-load dropdown chunks into the main bundle.
import Dropdown from '@/components/elements/Dropdown.vue';
import CategoriesDropdownRectangle from '@/components/elements/CategoriesDropdownRectangle.vue';
import store from '@/store/index.js';
import {dashboardReloadNoticeSuppressed} from '@/lib/dashboardReloadNotice';
import {sendLogs} from '@/utils/errorHandler.js';
import {bootstrapUserOnce} from '@/utils/bootstrapUser.js';

const defaultLayout = 'default';

export default {
  name: 'App',
  components: {
    FygrSelector,
    DeletePrimaryAccountPopup,
    Dropdown,
    CategoriesDropdownRectangle,
    FygrInteractiveNotification: defineAsyncComponent(
      () => import('@/components/elements/FygrInteractiveNotification.vue'),
    ),
    Markdown: defineAsyncComponent(
      () => import('@/components/elements/MarkDown.vue'),
    ),
    AdBlockPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AdBlockPopup.vue'),
    ),
    AccountRemovedPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AccountRemovedPopup.vue'),
    ),
    NewAccountDetectedPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/NewAccountDetectedPopup.vue'),
    ),
    AddBankPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AddBankPopup.vue'),
    ),
    AddDataSourcePopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AddDataSourcePopup.vue'),
    ),
    AddBanksMobileFrame: defineAsyncComponent(
      () => import('@/components/elements/AddBanksMobileFrame.vue'),
    ),
    AddUsersMobileFrame: defineAsyncComponent(
      () => import('@/components/elements/AddUsersMobileFrame.vue'),
    ),
    DefaultMobileFrame: defineAsyncComponent(
      () => import('@/components/elements/DefaultMobileFrame.vue'),
    ),
    AddUserPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AddUserPopup.vue'),
    ),
    SubscriptionLimitPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/SubscriptionLimitPopup.vue'),
    ),
    CpaTrialPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/CpaTrialPopup.vue'),
    ),
    CreatingCompanyPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/CreatingCompanyPopup.vue'),
    ),
    DeleteConfirmationPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/DeleteConfirmationPopup.vue'),
    ),
    Card3dsValidationQueue: defineAsyncComponent(
      () => import('@/components/elements/Card3dsValidationQueue.vue'),
    ),
    OnboardingLayout: defineAsyncComponent(
      () => import('@/components/layouts/OnboardingLayout.vue'),
    ),
    SigninPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/SigninPopup.vue'),
    ),
    SepaPaywall: defineAsyncComponent(
      () => import('@/components/widgets/SepaPaywall.vue'),
    ),
    // TooManyConnectionsPopup: defineAsyncComponent(
    //   () => import('@/components/elements/popups/TooManyConnectionsPopup.vue'),
    // ), TODO remove after 01.10.25 if not needed
    TrialLayout: defineAsyncComponent(
      () => import('@/components/layouts/trial-layout.vue'),
    ),
    UnlockFeaturePopup: defineAsyncComponent(
      () => import('@/components/elements/popups/UnlockFeaturePopup.vue'),
    ),
    UpgradePlanPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/UpgradePlanPopup.vue'),
    ),
    UpgradePlanV1Popup: defineAsyncComponent(
      () => import('@/components/elements/popups/UpgradePlanV1Popup.vue'),
    ),
    SideHelpComponent: defineAsyncComponent(
      () => import('@/components/elements/SideHelpComponent.vue'),
    ),
    DefaultLayout: defineAsyncComponent(
      () => import('@/components/layouts/DefaultLayout.vue'),
    ),
    EmptyLayout: defineAsyncComponent(
      () => import('@/components/layouts/EmptyLayout.vue'),
    ),
  },
  mixins: [
    companyMixin,
    cpaMixin,
    mobileMixin,
    pagesChecker,
    paywallMixin,
    appMixin,
    StripeMixin,
    checkUpdatesMixin,
  ],
  data() {
    return {
      bankDelPicked: 'del',
      deletingPrimaryAcc: false,
      showCompanyChangeNotification: false,
      showDashboardReloadNotification: false,
      additionalUpdateData: null,
      headerHeight: 75,
      ShowSideHelpComponent: false,
      addBankSuggestion: false,
      accountsPendingDeletion: [],
      reviewingAccountDeletion: false,
      addBankPopupDisplayed: false,
      accountsAwaitingApproval: [],
      reviewingDetectedAccount: '',
      addingUser: null,
      bankAndAggregators: [],
      popupConfirmDeleteCompany: false,
      deletingCompany: false,
      popupConfirmDeleteBank: false,
      deletingBank: false,
      idToDelete: null,
      isUser: true,
      mobile: false,
      customType: 'bank',
      adBlockEnabled: false,
      creatingCompany: false,
      isCreatingCompany: false,
      cpaCompany: null,
      cpaTrialLimit: false,
      wrongLength: false,
      mayBeCreated: false,
      basePlan: null,
      showFeaturePopup: false,
      showUpgradePopup: false,
      showUpgradeV1Popup: false,
      updatingSubscription: false,
      dmfInput: '',
      companySiret: '',
      finishedAuth: false,
      // Company-scoped bootstrap bookkeeping: which company we already loaded,
      // and the in-flight promise so concurrent triggers share one round of
      // requests instead of firing a second one.
      bootstrappedCompanyId: null,
      companyBootstrapPromise: null,
      deletingIntegration: false,
      showDeleteIntegration: false,
      partnerToDelete: null,
    };
  },
  computed: {
    ...mapGetters('bank', ['bankNumber', 'accountsDDOptions']),
    ...mapGetters('user', [
      'activeUser',
      'getLocale',
      'forecastByAccount',
      'defaultForecastingAccount',
    ]),
    ...mapState('app', [
      'globalLoading',
      'loading',
      'loadingTitle',
      'notifications',
      'tou',
      'inAppMessage',
    ]),
    ...mapState('onboarding', ['chapters']),
    ...mapState('bank', ['banks']),
    ...mapState('company', ['stylesLoaded']),
    ...mapState('partner', ['partnerIntegrationVisibility']),
    ...mapState('user', [
      'authorized',
      'companiesLoaded',
      'permissions',
      'user',
      'maxConnections',
      'companies',
      'isStandalone',
      'isCompanyCpa',
      'signinPopup',
      'isAdBlockerDetected',
    ]),
    ...mapState('subscription', ['subscription', 'managedTrial', 'showTrial']),
    // Root state: mirrors FYGR_COMPANY. Watched below so the company-scoped
    // bootstrap also runs when the company only appears mid-session.
    ...mapState(['companyId']),
    accountPendingDeletion() {
      return this.accountsPendingDeletion[0] || null;
    },
    // One popup at a time: the next detected account comes up once this one is answered.
    detectedAccount() {
      return this.accountsAwaitingApproval[0] || null;
    },
    supprimerTranslated() {
      return SUPPRIMERTRANSLATED[this.getLocale.toUpperCase()];
    },
    mdHTML() {
      return this.inAppMessage.body || '';
    },
    v0Required() {
      return !this.subscription.free_trial_version || !this.subscription.trial;
    },
    generalLoader() {
      return this.globalLoading || !this.stylesLoaded || !this.companiesLoaded;
    },
    hideApp() {
      return (
        !this.subscription.has_subscription &&
        !this.subscription.trial &&
        !this.isStandalone &&
        !this.isCpaUser(this.activeUser) &&
        !this.loading &&
        Object.entries(this.subscription).length &&
        !this.subscription.default
      );
    },
    // --- SEPA payment failure paywall (TT-6066) ---
    // `account_blocked` is authoritative (the backend does the 30-day grace
    // math). The full-screen paywall is non-bypassable — it settles the card
    // catch-up payment inline, so no route is exempted.
    ...mapGetters('paywall', {sepaBlockActive: 'accountBlocked'}),
    hideOnboardingButton() {
      const routeName = this.$route?.name;
      return (
        routeName?.includes('onboarding') ||
        routeName?.includes('personal-infos') ||
        routeName?.includes('company-infos')
      );
    },
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
    keyHolder() {
      return `${this.$route.fullPath}`;
    },
    ownerEmail() {
      const id = localStorage.getItem('FYGR_COMPANY');
      return this.companies?.[id]?.[1] || '';
    },
    validBanks() {
      // `banks` is null until the company-scoped bootstrap runs.
      return (this.banks || []).filter((b) => b.aggregator);
    },
  },
  watch: {
    /* Paywall franchi en cours de session (souscription, bypass) : `showTrial`
       retombe sans rechargement. On enchaîne aussitôt sur la « 2ᵉ source » plutôt
       que d'attendre le prochain mount — c'est l'étape qui précède le tuto. */
    showTrial(nv, ov) {
      if (ov && !nv) this.maybePromptSecondDataSource();
    },
    /* Banks load after mount: re-evaluate when they arrive rather than betting
       on a fixed delay. Only react to the "no source → at least one" transition:
       a mid-session add (N → N+1) must not reopen the pop-up over the still-open
       add-bank modal. */
    banks(nv, ov) {
      if (!ov?.length && nv?.length) this.maybePromptSecondDataSource();
    },
    /* Idem pour l'onboarding (getStartOnboarding, chargé par le dashboard) : sans
       lui, `isOnboardingJourneyActive()` est faux au mount et l'étape serait
       systématiquement sautée. */
    chapters(nv) {
      if (nv?.length) this.maybePromptSecondDataSource();
    },
    async permissions(nv) {
      if (
        nv &&
        (nv.write_payment ||
          nv.read_payment ||
          nv.manage_own_payment_cards ||
          nv.manage_all_payment_cards)
      ) {
        try {
          await this.actionGetPending3DsValidation();
          // Case 3: seed the realtime validation queue with the ops already
          // pending at login, newest-first.
          await store.dispatch('validation3ds/seedFromPending');
          // Populate the notification center + bell badge on cold load.
          await store.dispatch('notifications/actionListNotifications');
        } catch (err) {
          this.actionAddNotification({
            msg:
              err?.userMessage ||
              'Erreur lors de la récupération des opérations à valider',
            color: 'red',
            disappearing: true,
            once: true,
          });
        }
      }
    },
    async authorized(nv) {
      if (nv) {
        await store.dispatch('actionSetCompanyId');
        this.loadSponsorhip();
        // During signup the company isn't created yet (it's created at the last
        // onboarding step), so the company-scoped bootstrap is a no-op here —
        // the `companyId` watcher below picks it up once the company exists.
        await this.bootstrapCompanyState(localStorage.getItem('FYGR_COMPANY'));
        setTimeout(() => this.loadStripeScript(), 2000);
        this.finishedAuth = true;
      } else {
        this.finishedAuth = false;
        this.accountsPendingDeletion = [];
        this.bootstrappedCompanyId = null;
        this.companyBootstrapPromise = null;
        await this.actionUnauthBanks();
        this.actionUnauthApp();
        this.$store.commit('paywall/resetPaywall');
      }
    },
    // The company can appear mid-session: in the deferred-company signup flow
    // `authorized` already flipped to true while FYGR_COMPANY was still null,
    // so that one-shot transition can't bootstrap it (TT-7152).
    companyId(nv) {
      if (nv && this.authorized) {
        // Errors are already surfaced by the individual actions.
        this.bootstrapCompanyState(nv).catch(() => {});
      }
    },
    // Re-check the paywall on authenticated navigation (spec §4.1). The action
    // is cached ~60s client-side, so this doesn't spam the endpoint per route.
    $route() {
      if (this.authorized && localStorage.getItem('FYGR_COMPANY')) {
        this.actionGetPaywallStatus().catch(() => {});
      }
    },
    companies: {
      handler() {
        const companyId = localStorage.getItem('FYGR_COMPANY');
        // Mid-signup the company doesn't exist yet: companies is {} and
        // FYGR_COMPANY is null, so guard the keyed access — otherwise a
        // CPA-role user throws on companies[null][2] here.
        if (this.companies?.[companyId] && this.isCpaUser(this.activeUser)) {
          const cpaId = this.companies[companyId][2] || companyId;
          this.actionGetTrialCpaChildren({companyId: cpaId});
        }
      },
      deep: true,
    },
    getLocale: {
      handler() {
        this.loadSponsorhip();
      },
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScaleAndZoom);
    window.removeEventListener('storage', this.handleStorage);
  },
  created() {
    document.body.classList.add('body-opacity-1'); // temporary unflicker solution (TT-3944)
  },
  async beforeMount() {
    // `mayBeCreated` gates router-view, so it has to be set even when the bootstrap
    // fails — otherwise a failed init leaves the app on a loader that never clears.
    try {
      await this.init();
    } finally {
      this.mayBeCreated = true;
    }
  },
  async mounted() {
    this.mobile = this.mobileDevicesRegex.some((mdr) =>
      navigator.userAgent.match(mdr),
    );
    this.checkScaleAndZoom();
    // Hide the Intercom launcher bubble on every viewport. The messenger can
    // still be opened programmatically via window.Intercom('show') from the
    // various "contact support" buttons. Intercom is loaded as a Segment
    // destination, so wait for analytics to be ready before configuring it.
    window.analytics?.ready?.(() => {
      window.Intercom?.('update', {
        hide_default_launcher: true,
        alignment: 'right',
        horizontal_padding: 20,
        vertical_padding: 20,
      });
    });
    await this.actionDetectAdBlocker();
    setTimeout(async () => {
      if (!localStorage.getItem('AD_BLOCKER_WARNING_SEEN')) {
        this.adBlockEnabled = this.isAdBlockerDetected;
      }
    }, 2000);
    AppBus.$on('unlock', (e) => {
      this.basePlan = e;
      this.showUpgradePopup = true;
    });
    AppBus.$on('unlockV1', (e) => {
      this.basePlan = e;
      this.showUpgradeV1Popup = true;
    });
    AppBus.$on('dashboard-invalidated', () => {
      // A running tutorial (or one just exited) seeds/cleans sandbox data, which
      // invalidates the dashboard: don't surface the "new data / reload" notice.
      // The grace window covers the async invalidation fired by the exit cleanup.
      if (window.FygrTour?.reloadSuppressed?.()) return;
      // Invalidation causée par cet onglet, qui rafraîchit déjà ses données.
      if (dashboardReloadNoticeSuppressed()) return;
      if (this.$route?.name === 'dashboard') {
        this.showDashboardReloadNotification = true;
      }
    });
    // A tutorial is starting: hide any reload notice that was already showing.
    AppBus.$on('tour:reset-state', () => {
      this.showDashboardReloadNotification = false;
    });

    this.maybePromptSecondDataSource();
    window.addEventListener('load', () => {
      this.headerHeight =
        document.getElementById('nav') &&
        document.getElementById('nav').clientHeight
          ? document.getElementById('nav').clientHeight
          : 75;
    });
    window.addEventListener('resize', this.checkScaleAndZoom);
    setTimeout(() => {
      document.body.classList.remove('body-opacity-1');
    }, 8000); // temporary unflicker solution (TT-3944)
    window.addEventListener('storage', this.handleStorage);
  },
  updated() {
    nextTick(() => {
      // The launcher is hidden on every viewport (see mounted), so re-assert it
      // on re-render in case Intercom re-shows it.
      window.Intercom?.('update', {hide_default_launcher: true});
    });
  },
  methods: {
    ...mapActions('app', [
      'actionSetAppLoaded',
      'actionAddNotification',
      'actionRemoveNotification',
      'actionGetTou',
      'actionUnauthApp',
      'actionSetScalingCoeff',
      'actionHideInAppMessage',
    ]),
    ...mapActions('bank', [
      'actionGetBanksAndAccountsList',
      'actionDeleteConnection',
      'actionUnauthBanks',
      'actionSetMasterCookie',
      'actionGetAccountsPendingDeletion',
      'actionReviewAccountDeletion',
      'actionGetAccountsAwaitingApproval',
      'actionReviewAccount',
    ]),
    async loadAccountsAwaitingApproval() {
      this.accountsAwaitingApproval =
        await this.actionGetAccountsAwaitingApproval();
    },
    // Closing decides nothing: the account stays pending and comes back on the next load,
    // but the ones behind it in the queue still get their turn now.
    dismissDetectedAccount() {
      this.accountsAwaitingApproval = this.accountsAwaitingApproval.slice(1);
    },
    async reviewDetectedAccount(account, approved) {
      this.reviewingDetectedAccount = approved ? 'approve' : 'reject';
      try {
        const res = await this.actionReviewAccount({
          accountExId: account.ex_id,
          approved,
        });
        if (res?.error) return;
        this.accountsAwaitingApproval = this.accountsAwaitingApproval.filter(
          (a) => a.ex_id !== account.ex_id,
        );
        if (approved) {
          await this.actionGetBanksAndAccountsList();
        }
      } finally {
        this.reviewingDetectedAccount = '';
      }
    },
    ...mapActions('billing', [
      'actionGetCurrentBasePlan',
      'actionUpdateSubscription',
    ]),
    ...mapActions('eBanking', ['actionGetPending3DsValidation']),
    ...mapActions('user', [
      'actionGetUserProfile',
      'actionGetEmployeeList',
      'actionConnectionsRequest',
      'actionGetDefaultCurrency',
      'actionGetCompaniesList',
      'actionCreateCompany',
      'actionGetMaxConnections',
      'actionGetMaxCategoryDepth',
      'actionGetPermissions',
      'actionDeleteCompany',
      'actionFinishSignup',
      'actionUpdateCompany',
      'actionDetectAdBlocker',
      'actionInitSponsorhip',
      'actionGetCompanyInfo',
    ]),
    ...mapActions('provider', ['actionGetBanksAndAggreagtors']),
    ...mapActions('subscription', [
      'actionGetSubscriptionForCompany',
      'actionChangeShowTrial',
      'actionChangeShowTrialButton',
      'actionGetTrialCpaChildren',
      'actionRemoveFromManagedTrial',
    ]),
    ...mapActions('partner', ['actionDeletePartnerIntegration']),
    ...mapActions('paywall', ['actionGetPaywallStatus']),
    // Everything company-scoped the app needs before any page can act. Keyed on
    // the companyId rather than on the `authorized` flip so it also runs when
    // the company is created mid-session (deferred-company signup, TT-7152).
    // Idempotent: concurrent callers share the in-flight promise, so a reload
    // (where both `authorized` and `companyId` change) still issues one round.
    async loadAccountsPendingDeletion() {
      if (!this.permissions?.bank_management) return;
      this.accountsPendingDeletion =
        await this.actionGetAccountsPendingDeletion();
    },
    async reviewAccountPendingDeletion(confirmed) {
      const account = this.accountPendingDeletion;
      if (!account || this.reviewingAccountDeletion) return;
      this.reviewingAccountDeletion = true;
      try {
        await this.actionReviewAccountDeletion({
          accountExId: account.ex_id,
          confirmed,
        });
        if (confirmed) await this.actionGetBanksAndAccountsList();
      } catch {
        this.actionAddNotification({
          msg: "Le compte n'a pas pu être mis à jour, veuillez réessayer",
          color: 'red',
          disappearing: true,
          once: true,
        });
      } finally {
        // Dropped either way: the backend still holds it as suspected, so a
        // failed review comes back at the next load rather than looping here.
        this.skipAccountPendingDeletion();
        this.reviewingAccountDeletion = false;
      }
    },
    confirmAccountDeletion() {
      return this.reviewAccountPendingDeletion(true);
    },
    async disputeAccountDeletion() {
      await this.reviewAccountPendingDeletion(false);
      if (window.Intercom) window.Intercom('show');
    },
    skipAccountPendingDeletion() {
      this.accountsPendingDeletion = this.accountsPendingDeletion.slice(1);
    },
    bootstrapCompanyState(companyId) {
      if (!companyId) {
        return Promise.resolve();
      }
      if (this.bootstrappedCompanyId === companyId) {
        return this.companyBootstrapPromise || Promise.resolve();
      }
      this.bootstrappedCompanyId = companyId;
      this.companyBootstrapPromise = (async () => {
        try {
          await this.actionGetBanksAndAccountsList();
          await this.actionGetPermissions();
          await this.actionGetDefaultCurrency();
          await this.actionGetUserProfile();
          await this.actionGetMaxConnections();
          await this.actionGetMaxCategoryDepth();
          await this.actionGetCompaniesList();
          await this.actionGetCompanyInfo(companyId);
          await this.actionSetMasterCookie();
          // SEPA paywall (TT-6066): fetch once on login; the blocking decision
          // is owned by the backend `account_blocked` flag.
          this.actionGetPaywallStatus().catch(() => {});
          this.loadAccountsPendingDeletion().catch(() => {});
          this.loadAccountsAwaitingApproval().catch(() => {});
        } catch (err) {
          // Don't cache a failure: let a later trigger retry. Rethrow so the
          // `authorized` watcher still bails before `finishedAuth`, as before.
          this.bootstrappedCompanyId = null;
          this.companyBootstrapPromise = null;
          throw err;
        }
      })();
      return this.companyBootstrapPromise;
    },
    handleStorage(e) {
      if (e.key === 'FYGR_COMPANY') {
        this.showCompanyChangeNotification = true;
      }
    },
    checkScaleAndZoom() {
      const firefox = navigator.userAgent.match(/firefox|fxios/i);
      const macos = navigator.userAgent.match(/mac/i);
      if (this.mobile) return;
      // outerWidth can briefly be 0 at mount in some Chrome contexts; -> infinity zoom
      if (!window.outerWidth) {
        requestAnimationFrame(this.checkScaleAndZoom);
        return;
      }
      this.actionSetScalingCoeff({
        dpr: firefox || macos ? 1 : window.devicePixelRatio,
        zoom: Math.round((window.innerWidth / window.outerWidth) * 100),
      });
    },
    loadSponsorhip() {
      // if (this.getLocale === 'fr') {
      //   this.actionInitSponsorhip();
      // }
    },
    closeAdBlocker() {
      this.adBlockEnabled = false;
      localStorage.setItem('AD_BLOCKER_WARNING_SEEN', true);
    },
    async deleteIntegration() {
      this.deletingIntegration = true;
      await this.actionDeletePartnerIntegration({
        partner_id: this.partnerToDelete.partner_id,
        partner_integration_id: this.partnerToDelete.partner_integration_id,
      });
      localStorage.removeItem('FYGR_CURRENT_SELECTED_PARTNER');
      this.deletingIntegration = false;
      this.showDeleteIntegration = false;
      window.location.reload();
    },
    showAddBankSuggestion() {
      this.addBankSuggestion = true;
      // Retient l'auto-ouverture du recap tant que cette pop-up est à l'écran :
      // l'ordre voulu est paywall → « 2ᵉ source » → tuto.
      setDataSourcePopupPending(true);
    },
    /* « 2ᵉ source de données » : proposée UNE FOIS, une fois le paywall franchi.
       On se base sur l'ÉTAT (paywall + sources connectées + étape non consommée)
       et non sur l'instant d'une synchro : le parcours réel s'étale sur plusieurs
       sessions, donc un déclencheur ponctuel se perd au moindre rechargement. */
    maybePromptSecondDataSource() {
      // The "2nd source" is a step of the dashboard onboarding flow: only offer
      // it there. Otherwise a state-based trigger (e.g. the socle being seeded
      // when /guide opens) would pop it out of context.
      if (this.$route?.name !== 'dashboard') return;
      if (this.addBankSuggestion) return; // already on screen (end of sync)
      if (isSecondSourceResolved()) return; // already offered this session
      if (!isOnboardingJourneyActive()) return; // sign-ups only
      if (this.showTrial) return; // paywall still in front: it comes after
      if (!this.banks.length) return; // no source yet → nothing to complete
      // Don't open over a bank-add in progress: the pop-up would show up
      // "behind" that modal.
      if (this.addBankPopupDisplayed) return;
      this.showAddBankSuggestion();
    },
    // Fermeture de la pop-up « 2ᵉ source », quel que soit le bouton (ajouter une
    // source, aller au dashboard, croix) → étape résolue pour la session, puis
    // on enchaîne sur le tuto.
    closeAddBankSuggestion() {
      this.addBankSuggestion = false;
      // Marque l'étape résolue (dans resumeOnboardingAfterPopupFlow) puis enchaîne
      // sur le tuto — le maillon paywall → « 2ᵉ source » → tuto.
      resumeOnboardingAfterPopupFlow();
    },
    checkRouteAllowedShowBanner(inAppMessage) {
      if (!inAppMessage.routes || inAppMessage.routes.length === 0) {
        return true;
      }
      let res = false;
      inAppMessage.routes.forEach((item) => {
        if (item === this.$route.path) {
          res = true;
        }
        // if (item.includes('*') && this.$route.matched[0]
        //   && this.$route.matched[0].path === (item.replace(/\*/g, ''))) {
        //   res = true;
        // }
      });
      return res;
    },
    async addUser(e) {
      const companyId = localStorage.getItem('FYGR_COMPANY');
      this.basePlan = await this.actionGetCurrentBasePlan({companyId});
      let {employees} = e;
      if (!employees) {
        const res = await this.actionGetEmployeeList({
          companyId: e.companyId,
          getAll: this.isCompanyCpa,
        });
        employees = res.users;
      }
      this.addingUser = {...e, employees};
    },
    confirmUpgrade() {
      this.showUpgradePopup = false;
      this.showUpgradeV1Popup = false;
      if (this.basePlan.type === 'bank') {
        this.showAddBankPopup();
      } else if (this.basePlan.type === 'user') {
        this.$refs.view.addUser();
      }
      AppBus.$emit('updateBasePlan');
    },
    async updateAdditionalSubscriptions() {
      this.updatingSubscription = true;
      const companyId = localStorage.getItem('FYGR_COMPANY');
      const event = this.basePlan.updateEvent;
      await this.actionUpdateSubscription({
        companyId,
        events: {...event, plans: this.basePlan.current_base_plan},
        from_event: true,
      })
        .then(async () => {
          await this.actionGetSubscriptionForCompany();
          AppBus.$emit('updateSubscriptionVar');
          this.actionAddNotification({
            msg: 'Votre abonnement a bien été modifié',
            color: 'green',
            disappearing: true,
            once: true,
          });
          this.basePlan = null;
        })
        .catch((err) => {
          if (err.message === 'Could not create a new customer on Stripe.') {
            this.actionAddNotification({
              msg: 'Veuillez commencer par remplir les informations de facturation.',
              color: 'red',
              disappearing: true,
              once: true,
            });
          } else {
            this.actionAddNotification({
              msg: "Échec de l'application du plan sélectionné",
              color: 'red',
              once: true,
            });
          }
        })
        .finally(() => {
          this.updatingSubscription = false;
          this.additionalUpdateData = null;
        });
    },
    updateUsersTable() {
      if (this.$refs.view.updateUsersTable) {
        this.$refs.view.updateUsersTable();
      }
    },
    async showAddBankPopup() {
      // The whole body is guarded: this runs from a click handler, so an
      // uncaught throw used to reject silently and leave the button dead
      // (TT-7152).
      try {
        const companyId = localStorage.getItem('FYGR_COMPANY');
        // `banks` is loaded by the company bootstrap. If a caller gets here
        // first, load it now rather than falling through to the throw below.
        if (!this.banks) {
          await this.actionGetBanksAndAccountsList();
        }
        this.basePlan = await this.actionGetCurrentBasePlan({companyId}).catch(
          () => {
            this.actionAddNotification({
              msg:
                'Erreur lors de la récupération des données BasePlan. ' +
                'Si le problème persiste, veuillez contacter le support',
              color: 'red',
              disappearing: true,
              once: true,
            });
          },
        );
        if (this.maxConnections <= this.validBanks.length) {
          this.isUser = false;
          this.$router.push({name: 'book-a-meeting'});
          return;
        }
        if (this.checkLimits('bank')) {
          return;
        }
        if (this.banks) {
          this.addBankPopupDisplayed = true;
          return;
        }
        throw new Error(
          `ShowAddBankPopup no branch executed. this.banks=${this.banks?.length}, this.checkLimits=${this.checkLimits('bank')}, this.maxConnections= ${this.maxConnections}`,
        );
      } catch (err) {
        // Still reported: now that it's caught here, the rejection no longer
        // reaches the global unhandledrejection listener.
        sendLogs({
          type: 'showAddBankPopup',
          level: 'error',
          message: err?.message || 'showAddBankPopup failed',
          stack: err?.stack || null,
          url: window.location.href,
        });
        this.actionAddNotification({
          msg:
            "Impossible d'ouvrir la connexion bancaire. " +
            'Si le problème persiste, veuillez contacter le support',
          color: 'red',
          disappearing: true,
          once: true,
        });
      }
    },
    showCreateCompany() {
      if (this.isCpaUser(this.activeUser) && this.managedTrial.length >= 2) {
        this.cpaTrialLimit = true;
        return;
      }
      let companyId = localStorage.getItem('FYGR_COMPANY');
      if (this.companies[companyId] && this.companies[companyId][2]) {
        [, , companyId] = this.companies[companyId];
      }
      this.cpaCompany = this.isCpaUser(this.activeUser) ? companyId : null;
      this.creatingCompany = true;
    },
    showConfirmDeleteBank(id) {
      this.idToDelete = id;
      this.popupConfirmDeleteBank = true;
      if (this.forecastByAccount) {
        const bank = this.accountsDDOptions.find((bank) => bank.id === id);
        const isAccountDefaultDel = bank?.list.find(
          (account) => account.id === this.defaultForecastingAccount,
        );
        if (isAccountDefaultDel) {
          this.deletingPrimaryAcc = true;
        }
      }
    },
    showConfirmDeletePartnerIntegration(partnerIntegration) {
      this.partnerToDelete = partnerIntegration;
      this.idToDelete = partnerIntegration.partner_id;
      this.showDeleteIntegration = true;
    },
    showConfirmDeleteCompany(id) {
      this.idToDelete = id;
      this.popupConfirmDeleteCompany = true;
    },
    async finishSubscription() {
      await this.actionGetSubscriptionForCompany();
      this.actionChangeShowTrial(false);
      this.actionChangeShowTrialButton(false);
    },
    async init() {
      const accessToken = localStorage.getItem('FYGR_ACCESS_TOKEN');
      // getting TOU for signup
      if (!this.tou) {
        await this.actionGetTou();
      }
      // An empty FYGR_COMPANY used to be read as "mid-signup", so the branch that skipped
      // resolution was the one taken whenever there was nothing to resolve from and a lost
      // company never came back. Only the backend can tell the two apart, so always ask.
      // Shared with the router guard, which awaits the same bootstrap before it decides
      // whether this account has a company — one round trip, whichever gets there first.
      if (accessToken) {
        await bootstrapUserOnce();
        this.actionSetAppLoaded(true);
      }
    },
    async confirmDeleteCompany() {
      this.deletingCompany = true;
      const res = await this.actionDeleteCompany({id: this.idToDelete});
      if (res && (res.error || res.status_code === 401)) {
        this.actionAddNotification({
          msg:
            'Une erreur est survenue lors de la suppression de la company. ' +
            'Un email a été envoyé avec les données à support@okimia.com',
          color: 'red',
          disappearing: true,
          once: true,
        });
        this.deletingCompany = false;
        return;
      }
      const currentCompanyId = localStorage.getItem('FYGR_COMPANY');
      if (currentCompanyId === this.idToDelete) {
        let companyList = await this.actionGetCompaniesList();
        companyList = Object.keys(companyList);
        this.switchCompany(companyList[0] || '', false, 'dashboard');
      } else {
        this.popupConfirmDeleteCompany = false;
        this.idToDelete = null;
        this.deletingCompany = false;
      }
    },
    async confirmDeleteBank() {
      this.deletingBank = true;
      const data = {
        id: this.idToDelete,
        delete_forecasts: this.bankDelPicked === 'del',
        transfer_forecasts: this.bankDelPicked === 'transfer',
      };
      await this.actionDeleteConnection(data).catch(() => {
        this.actionAddNotification({
          msg:
            "Votre banque n'a pas pu être supprimée. Une alerte a été envoyée à " +
            'support@okimia.com qui régularisera la situation dans les plus brefs délais.',
          color: 'red',
          disappearing: true,
          once: true,
        });
      });

      if (this.$refs.view.getBanksMC) {
        await this.$refs.view.getBanksMC({
          id: this.idToDelete.companyId,
          name: this.idToDelete.name,
        });
      }
      this.deletingBank = false;
      this.idToDelete = null;
      this.dmfInput = '';
      if (this.mobile) {
        this.$refs.delbank.close();
      } else {
        this.popupConfirmDeleteBank = false;
      }
    },
    async createNewCompany(dataIn) {
      this.isCreatingCompany = true;
      let processed;
      const {id} = await this.actionCreateCompany({
        name: dataIn.general.company.companyName,
        siret: dataIn.general.admin_information.establishment_id,
        parentId: this.cpaCompany ? this.cpaCompany : null,
      }).catch((err) => {
        this.isCreatingCompany = false;
        if (err.message === 'siret_in_use') {
          this.actionAddNotification({
            msg: 'Un entité avec ce SIRET existe déjà.',
            color: 'red',
            disappearing: true,
            once: true,
          });
        } else {
          this.actionAddNotification({
            msg: 'La création a échoué. Veuillez réessayer.',
            color: 'red',
            disappearing: true,
            once: true,
          });
        }
        processed = false;
      });
      if (processed === false) {
        return false;
      }
      await this.actionUpdateCompany({
        admin_information: dataIn.general.admin_information,
        company: dataIn.general.company,
        customization: {
          onboarding_customization_id: dataIn.customId,
        },
        id,
      });
      this.isCreatingCompany = false;
      this.cpaCompany = null;
      this.creatingCompany = false;
      this.switchCompany(id, this.$route.name, 'dashboard');
    },
  },
};
</script>
<style>
.body-opacity-1 {
  opacity: 1 !important;
}
</style>
<style lang="scss">
@media only screen and (max-width: 500px) {
  #hubspot-messages-iframe-container {
    transform: scale(0);
  }
}
#app {
  height: 100%;
}
.app {
  position: relative;
  height: 100%;
  .z-top {
    z-index: 999;
  }
  .fy-app-in-app-message {
    display: flex;
    width: 100%;
    position: relative;
    min-height: var(--px40);
    bottom: 0;
    .fy-app-in-app-message-close {
      position: absolute;
      right: var(--px15);
      top: calc(50% - var(--px8));
      color: #ffffff;
    }
  }
}
.general-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.chat-help {
  position: absolute;
  bottom: 0;
}
.fy-app-finish-signup-wrap {
  &.mobile {
    .fy-app-input {
      width: calc(100% - var(--px2));
    }
    .fy-app-confirm {
      width: 100%;
      font-size: var(--px20);
      max-height: var(--px50);
      min-height: var(--px50);
    }
  }
  .fy-app-input {
    width: var(--px358);
    &.fy-app-phone {
      .info-icon[class] {
        color: $gray;
        margin-bottom: var(--px2);
      }
    }
  }
  .fy-app-confirm {
    width: var(--px360);
    max-height: var(--px40);
    min-height: var(--px40);
    margin-top: var(--px20);
  }
}
.fy-app-dmf-container {
  display: flex;
  flex-direction: column;
  .fy-app-dmf-container-text {
    display: flex;
    margin-bottom: var(--px30);
    font-size: var(--px16);
  }
  .fy-app-dmf-container-input {
    margin-bottom: var(--px15);
    width: 100%;
    font-size: var(--px16);
    .invalid-prompt[class] {
      font-size: var(--px14);
    }
    input[class] {
      font-size: var(--px16);
      max-height: var(--px44);
      min-height: var(--px44);
    }
  }
  .fy-app-dmf-container-controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: var(--px16);
    margin-top: var(--px15);
    width: 100%;
    .fy-app-dmf-container-confirm {
      width: 100%;
      font-size: var(--px20);
      margin-bottom: var(--px20);
      font-weight: 500;
      height: var(--px50);
    }
    .fy-app-dmf-container-cancel {
      color: $aubergine;
      font-size: var(--px18);
      font-weight: 600;
    }
  }
}
.fy-app-md-container {
  width: 100%;
  min-height: var(--px40);
  display: flex;
  align-items: center;
  justify-content: center;
}
.fy-app-in-app-message-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss">
.trial-expired-mngd {
  display: flex;
  width: var(--px500);
  height: var(--px300);
  margin: calc(50vh - var(--px250)) auto;
  .lup-wrapper {
    margin: auto;
    align-items: center;
  }
  .lu-text-trial {
    width: var(--px260);
    text-align: center;
    a {
      text-decoration: none;
    }
  }
}
.global-spinner {
  z-index: 99;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(black, $alpha: 0.5);
  .loading-title {
    color: white;
    position: absolute;
    top: calc(50% + var(--px50));
    user-select: none;
  }
}
.notifications {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
  padding: var(--px5);
  display: flex;
  flex-direction: column;
}

.fy-app-sn-wrap {
  position: fixed;
  bottom: var(--px20);
  right: var(--px20);
  background: #ffffff;
  box-shadow: 0px var(--px4) var(--px4) rgba(0, 0, 0, 0.25);
  border-radius: var(--px4);
  width: var(--px300);
  height: var(--px85);
  z-index: 1;
  padding: var(--px20);
  display: flex;
  flex-direction: column;
  .fy-app-sn-controls {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-top: auto;
  }
  .fy-app-sn-close {
    position: absolute;
    right: var(--px10);
    top: var(--px10);
    color: $gray;
  }
}
.notification {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  width: var(--px250);
  max-width: var(--px250);
  min-height: var(--px50);
  cursor: default;
  border-radius: var(--px4);
  padding: var(--px24) var(--px24) var(--px16) var(--px16);
  color: white;
  margin: var(--px5);
  position: relative;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  &.bottom-space {
    margin-bottom: var(--px110);
  }
  &.gray-bg {
    background-color: rgba($gray, 0.8);
    &:hover {
      background-color: rgba($gray, 0.9);
    }
  }
  &.ebony-bg {
    background-color: rgba($ebony, 0.8);
    &:hover {
      background-color: rgba($ebony, 0.9);
    }
  }
  &.red-bg {
    background-color: rgba($red, 0.8);
    &:hover {
      background-color: rgba($red, 0.9);
    }
  }
  &.green-bg {
    background-color: rgba($success, 0.8);
    &:hover {
      background-color: rgba($success, 0.9);
    }
  }
  &.centered {
    text-align: center;
  }
  &.justified {
    text-align: justify;
  }
  &.left-aligned {
    text-align: left;
  }
  .close-notification-icon {
    cursor: pointer;
    position: absolute;
    top: var(--px16);
    right: var(--px16);
  }
}
.acc-forc {
  .selector-mobile {
    .fy-fs-el {
      font-size: var(--px16);
    }
  }
  .selector {
    margin-top: var(--px16);
  }
}
</style>
